//@flow
import React, {useState, useEffect} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';
import dueAlert from '../../../../assets/img/dueAlert.png';
import expiredAlert from '../../../../assets/img/expiredAlert.svg';
import calendarPurple from '../../../../assets/img/calendarPurple.svg';
import {useLocation} from 'react-router-dom';

import {
  DOWNGRADE_TIERS,
  FREE_TRIAL_TIERS,
  PAID_TIERS,
} from '../../../../entities';
import type {Subscription, StoreTier, User} from '../../../../entities';

import {connect} from 'react-redux';
import FreeTrialExpiringModal from '../../../home/components/Modals/FreeTrialExpiringModal';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {bindActionCreators} from 'redux';
import {useCurrentSubscription, useIsInEndSubscriptionDays} from '../../utils';

import {actions as ReferralActions} from '../../../referrals/duck';
import type {CreationRequest} from '../../../../entities';
import type {Dispatch} from 'redux';
import type {RootState} from '../../../../modules';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    dueInformation: state.tiersList.dueInformation,
    automaticCharge:
      state.accountConfig.subscriptionSetting &&
      state.accountConfig.subscriptionSetting.automaticCharge,
    storeTier: state.store.store && state.store.store.storeTier.name,
    storePreviousTier: state.store.storePreviousTier,
    isFetchingCreationRequest: state.referral.isFetchingCreationRequest,
    creationRequest: state.referral.creationRequest,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ReferralActions,
      },
      dispatch
    )
)(AlertDueDateTier);

type Props = {|
  dueInformation?: Subscription,
  automaticCharge?: boolean,
  storeTier: string,
  storePreviousTier?: StoreTier,
  user?: User,
  isFetchingCreationRequest?: boolean,
  creationRequest?: CreationRequest,
  fetchCreationRequest: () => void,
|};

const LOCALSTORAGE_FREETRIAL_MODAL = 'LOCALSTORAGE_FREETRIAL_MODAL_2';

const useStyles = typeAlert =>
  makeStyles(theme => ({
    alertWrap: {
      margin: theme.spacing(2),
      [theme.breakpoints.only('sm')]: {
        margin: theme.spacing(2, 4),
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(4, 4, 0, 4),
      },
    },
    alertContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
      // color: typeAlert === 1 ? 'black' : '#E13065',
      backgroundColor:
        typeAlert === 1
          ? '#F9EAD6'
          : typeAlert === 2
          ? '#FDEEF3'
          : colors.lightPurple,
      border: `1px solid ${
        typeAlert === 1
          ? '#F9EAD6'
          : typeAlert === 2
          ? '#F9CEDC'
          : colors.purple1
      }`,
      borderRadius: '12px',
      flexFlow: 'row',
      cursor: 'pointer',
    },
    contentWrapper: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        alignItems: 'unset',
        flexDirection: 'column',
      },
    },
    textAlertsWrapper: {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      paddingLeft: 20,
    },
    textAlert: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
      justifyContent: 'flex-start',
    },
    secondaryTextAlert: {
      whiteSpace: 'pre-line',
    },
    tertiaryTextAlert: {
      fontSize: '0.75rem',
      whiteSpace: 'pre-line',
    },
    linkAlert: {
      marginLeft: 'auto',
      borderRadius: 32,
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(2),
      },
      backgroundColor: typeAlert === 2 ? '#E13065' : '#7B39FF',
    },
    linkAlertWrap: {
      textAlign: 'center',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  }));

function AlertDueDateTier(props: Props) {
  const {
    storeTier,
    storePreviousTier,
    user,
    // fetchCreationRequest,
    // creationRequest,
    // isFetchingCreationRequest,
  } = props;

  const isRemaining7days = useIsInEndSubscriptionDays(7);
  // const [fetchStoreRedeem, setFetchStoreRedeem] = useState<boolean>(false);
  const [renewalModal, setRenewalModal] = useState(false);
  const [textAlert, setTextAlert] = useState('');
  const [secondaryTextAlert, setSecondaryTextAlert] = useState('');
  const [tertiaryTextAlert, setTertiaryTextAlert] = useState('');
  const [typeAlert, setTypeAlert] = useState(1);
  // 1 color rosado
  // 2 color warning

  const location = useLocation();

  const subscription = useCurrentSubscription();

  const classes = useStyles(typeAlert)();

  const localStorageFreeTrial = localStorage.getItem(
    LOCALSTORAGE_FREETRIAL_MODAL
  );
  const setLocalStorageFreeTrial = () => {
    localStorage.setItem(LOCALSTORAGE_FREETRIAL_MODAL, 'true');
  };

  const subscriptionEndDate = subscription?.endDate;

  useEffect(() => {
    if (storeTier && DOWNGRADE_TIERS.includes(storeTier)) {
      if (storePreviousTier && PAID_TIERS.includes(storePreviousTier.name)) {
        setTextAlert('Renovar suscripción para seguir utilizando TiendaDa');
        setSecondaryTextAlert('*Tu tienda ha sido deshabilitada.');
        setTypeAlert(2);
      } else if (storePreviousTier && storePreviousTier.name === 'TIER_11') {
        setTextAlert(
          '¡Alerta! Llegaste al máximo de ventas permitidas en la versión gratuita'
        );
        setSecondaryTextAlert(
          'Mejora tu plan para seguir creciendo con TiendaDa.\n*Tu tienda ha sido deshabilitada.'
        );
        setTypeAlert(3);
      } else {
        setTextAlert('Tu plan ha vencido');
        setSecondaryTextAlert('Renuévalo y sigue creciendo con TiendaDa 🚀');
        setTypeAlert(3);
      }
    } else if (subscriptionEndDate) {
      if (isRemaining7days) {
        if (FREE_TRIAL_TIERS.includes(storeTier)) {
          setRenewalModal(true);
          setTextAlert('Tu periodo de prueba está por terminar.');
          setSecondaryTextAlert(
            'Suscríbete a uno de nuestros planes y sigue creciendo con TiendaDa 🚀'
          );
          setTertiaryTextAlert(
            `Plan vence: ${new Intl.DateTimeFormat('es-PE', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            }).format(subscriptionEndDate)}`
          );
          setTypeAlert(3);
        } else {
          // setFetchStoreRedeem(true);
          setTextAlert('Tu suscripción está por terminar');
          setSecondaryTextAlert('Y tenemos el plan perfecto para ti.');
          setTypeAlert(1);
        }
      }
    }
  }, [isRemaining7days, storePreviousTier, storeTier, subscriptionEndDate]);

  // useEffect(() => {
  //   if (fetchStoreRedeem && !creationRequest) {
  //     fetchCreationRequest();
  //   }
  // }, [creationRequest, fetchCreationRequest, fetchStoreRedeem]);

  // useEffect(() => {
  //   if (creationRequest) {
  //     setTextAlert('Has canjeado tu suscripción PRO+');
  //     setSecondaryTextAlert('Al culminar tu plan actual, usarás tu beneficio.');
  //     setTypeAlert(1);
  //   }
  // }, [creationRequest]);

  const canShowButton =
    location &&
    (location.pathname !== '/tiers-list' || location.pathname !== '/profile');

  // if (isFetchingCreationRequest) return null;

  if (!isRemaining7days) return null;

  return (
    <>
      {FREE_TRIAL_TIERS.includes(storeTier) &&
        (!localStorageFreeTrial || localStorageFreeTrial !== 'true') &&
        user && (
          <FreeTrialExpiringModal
            open={renewalModal}
            handleClose={() => {
              setLocalStorageFreeTrial();
              setRenewalModal(false);
            }}
          />
        )}
      {
        <div className={classes.alertWrap}>
          <div className={classes.alertContainer}>
            <img
              src={
                typeAlert === 1
                  ? dueAlert
                  : typeAlert === 2
                  ? expiredAlert
                  : calendarPurple
              }
              alt=""
              height={65}
            />
            <div className={classes.contentWrapper}>
              <div className={classes.textAlertsWrapper}>
                <div className={classes.textAlert}>{textAlert}</div>
                {secondaryTextAlert && (
                  <div className={classes.secondaryTextAlert}>
                    {secondaryTextAlert}
                  </div>
                )}
                {tertiaryTextAlert && (
                  <div className={classes.tertiaryTextAlert}>
                    {tertiaryTextAlert}
                  </div>
                )}
              </div>
              {canShowButton && (
                <CustomButton
                  className={classes.linkAlert}
                  variant="contained"
                  color="primary"
                  to="/profile"
                >
                  Ver Planes
                </CustomButton>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

AlertDueDateTier.propTypes = {
  dueInformation: PropTypes.object,
  automaticCharge: PropTypes.bool,
  storeTier: PropTypes.string.isRequired,
  storePreviousTier: PropTypes.object,
  user: PropTypes.object,
  isFetchingCreationRequest: PropTypes.bool,
  fetchCreationRequest: PropTypes.func.isRequired,
  creationRequest: PropTypes.object,
};
